import classes from "./Advantage.module.scss";
import Tooltip from '../../Tooltip/tooltip';

import icon1 from "../../Assets/Img/Src/Svg/Icon/icon1.svg"
import icon2 from "../../Assets/Img/Src/Svg/Icon/icon2.svg"
import icon3 from "../../Assets/Img/Src/Svg/Icon/icon3.svg"
import icon4 from "../../Assets/Img/Src/Svg/Icon/icon4.svg"


const Advantage = () => {
  return (
    <div className={classes.Advantage}>
      <div className={classes.Item}>
        <div className={classes.Icon}><img src={icon1} alt="" /></div>
        <h5 className={classes.Title}>
        Evita<br/>
          косметологические<br/>
          салоны
      </h5>
        <p className={classes.Description}>
          Evita – компания, оказывающая косметологические услуги в своих московских салонах премиум класса
          <span> <Tooltip
            text={<>На данный момент открыто <br/><b>3 салона</b></>}/>
           </span>
        </p>
      </div>
      <div className={classes.Item}>
        <div className={classes.Icon}><img src={icon2} alt="" /></div>
        <h5 className={classes.Title}>2012<br /> интернет-магазин evitastore.ru
      </h5>
        <p className={classes.Description}>В 2012 году Evita открывает интернет-магазин Evitastore.ru
      </p>
      </div>
      <div className={classes.Item}>
        <div className={classes.Icon}><img src={icon3} alt="" /></div>
        <h5 className={classes.Title}>2018 - добавлены тысячи SKU, но результаты низкие
      </h5>
        <p className={classes.Description}>
          К 2018 году мультибрендовый интернет-магазин содержит уже тысячи SKU, однако результативность его очень низка
      </p>
      </div>
      <div className={classes.Item}>
        <div className={classes.Icon}><img src={icon4} alt="" /></div>
        <h5 className={classes.Title}>
          Evita
          <br/>
          +
          <br/>  
          Semprogroup
      </h5>
        <p className={classes.Description}> 
          В январе 2018 года Заказчик обращается к нам с задачей <br/> – понять, что происходит с  трафиком и увеличить<br/> темпы роста продаж
      </p>
      </div>
    </div>
  )
}

export default Advantage;